export const GET_PARENT_CATEGORY = "GET_PARENT_CATEGORY";
export const GET_CATEGORY_BY_SLUG = "GET_CATEGORY_BY_SLUG";
